module.exports = __webpack_public_path__ + "img/whatsapp-icon.66f8c735.png";